import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { util } from '../../classes/util';
import { ESRI } from '../../esri-loader-util';
import { BooleanConverter, InputConverter } from '../../inputConverter';
import { LayerService } from '../../services/layer.service';
import { PrintService } from '../../services/print.service';
import { LogLevel } from '../../types';
import { BaseComponent } from '../base.component';
var Graphic;
var SimpleLineSymbol;
var wait = 50;
var extentTrimAmount = 0.95;
var initilizeDebounceTime = 50;
var PrintComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PrintComponent, _super);
    function PrintComponent(_vcr, authService, layerService, printService, cdr, LoggingService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.authService = authService;
        _this.layerService = layerService;
        _this.printService = printService;
        _this.cdr = cdr;
        _this.LoggingService = LoggingService;
        _this.ondone = new EventEmitter();
        _this.onoutputloaded = new EventEmitter();
        _this.loadingOutputUrl = false;
        _this.outputLoaded = false;
        _this.layers = [];
        _this.defaultMapTitle = 'My Map';
        /**
         * If enabled, the legend will be included in the exported map.
         * If disabled, the legend will be omitted from the exported map.
         */
        _this.includeLegend = true;
        /**
         * Indicates whether the advanced options panel is expaned or collapsed.
         */
        _this.isAdvancedOptionsExpanded = false;
        /**
         * Copyright text to display in the exported map.
         */
        _this.copyright = 'PennDOT';
        /**
         * The units the scalebar use in the exported map.
         */
        _this.scalebarUnits = 'Miles';
        /**
         * The output format to use in the exported map.
         */
        _this.format = 'pdf';
        /**
         * Scale drawing layers to extent.
         */
        _this.scaleDrawingLayers = false;
        /**
         * When checked, the user will receive an email when the export has completed.
         */
        _this.isReceiveEmailChecked = false;
        /**
         * Basemap setting
         */
        _this.useCurrentBasemap = true;
        /**
         * The unique id for the extent graphics layer used by this component.
         */
        _this.extentLayerId = "mc-print-extent-" + _this.componentId;
        /**
         * Legend table
         */
        // private legendTable = [];
        /**
         * Checks if any layers have routing details
         */
        _this.hasRoutingDetails = false;
        _this._restarted = false;
        _this.initializing = false;
        _this.listners = [];
        _this.registerEvent('ondone', _this.ondone);
        _this.registerEvent('onoutputloaded', _this.onoutputloaded);
        return _this;
    }
    Object.defineProperty(PrintComponent.prototype, "active", {
        get: function () {
            return this._active;
        },
        set: function (value) {
            if (value) { // detail is value prop sent by angular event
                this._active = value;
                if (!this.loadingOutputUrl && !this.outputLoaded) {
                    this.onActivate();
                }
                this.setupHandleHiddenLayer();
            }
            else {
                this.reset();
                this._active = false;
                this.teardownHandleHiddenLayer();
            }
        },
        enumerable: true,
        configurable: true
    });
    PrintComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, error_1;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.drawExtent = util.debounce(this.drawExtentWork.bind(this), initilizeDebounceTime);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, Promise.all([ESRI.Graphic, ESRI.SimpleLine])];
                    case 2:
                        _a = tslib_1.__read.apply(void 0, [_c.sent(), 2]), Graphic = _a[0], SimpleLineSymbol = _a[1];
                        _b = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 3:
                        _b.mapView = _c.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        error_1 = _c.sent();
                        this.readyProblem(error_1);
                        return [3 /*break*/, 6];
                    case 5:
                        this.isReady();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PrintComponent.prototype, "selectedLayout", {
        /**
         * The selected print layout
         */
        get: function () {
            return this._selectedLayout;
        },
        set: function (value) {
            this._selectedLayout = value;
            this.drawExtent();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrintComponent.prototype, "formatDisplay", {
        get: function () {
            var retVal = '';
            switch (this.format) {
                case 'pdf':
                    retVal = 'PDF';
                    break;
                case 'png':
                    retVal = 'PNG';
                    break;
                case 'jpg':
                    retVal = 'JPG';
                    break;
                default:
                    retVal = 'Output';
                    break;
            }
            return retVal;
        },
        enumerable: true,
        configurable: true
    });
    PrintComponent.prototype.onActivate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, anyHaveRoutingDetails, _b, _c, layer;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, Promise.all([this.getCurrentUser(), this.loadLayouts()])];
                    case 1:
                        _d.sent();
                        this.scaleWatcher = this.mapView.watch('stationary', function (stationary) {
                            if (stationary) {
                                // Map stopped moving, check if print extent is still contained on the screen
                                if (!_this.extentLayer || !_this.extentLayer.graphics.length || !_this.mapView.extent.contains(_this.extentLayer.graphics.getItemAt(0).geometry.extent)) {
                                    if (_this.sketch) {
                                        _this.sketch.complete();
                                    }
                                    _this.drawExtent();
                                }
                            }
                        });
                        this.layers = this.mapView.map.layers.toArray().reverse();
                        anyHaveRoutingDetails = false;
                        try {
                            for (_b = tslib_1.__values(this.layers), _c = _b.next(); !_c.done; _c = _b.next()) {
                                layer = _c.value;
                                if (layer.mapcoreProps) {
                                    layer.mapcoreProps.showInPrintLegend = true;
                                    if (layer.mapcoreProps.routingDetail) {
                                        layer.mapcoreProps.printRoutingDetail = true;
                                        anyHaveRoutingDetails = true;
                                    }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        this.hasRoutingDetails = anyHaveRoutingDetails;
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    PrintComponent.prototype.getCurrentUser = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.authService.user.subscribe(function (user) {
                    if (user) {
                        _this.user = user;
                        _this.author = user.emailAddress;
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    PrintComponent.prototype.loadLayouts = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.printService.loadLayouts()];
                    case 1:
                        _a.layouts = _b.sent();
                        if (!this.selectedLayout) {
                            this.selectedLayout = this.layouts[0];
                        }
                        else {
                            this.selectedLayout = this.layouts.find(function (x) { return x.id === _this.selectedLayout.id; });
                            this.drawExtent();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Draw the current user's extent on the map, bounded by their selected template.
     * Safe to call many times, as this redraws every time.
     */
    PrintComponent.prototype.drawExtentWork = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var extent, polygon, graphic;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.selectedLayout) {
                            this.loadLayouts();
                        }
                        if (!!this.extentLayer) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.createExtentLayer()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(this.mapView && this.extentLayer && this.selectedLayout)) return [3 /*break*/, 6];
                        this.sketch.view = this.mapView;
                        this.sketch.viewModel.defaultUpdateOptions.enableScaling = true;
                        this.sketch.viewModel.defaultUpdateOptions.preserveAspectRatio = true;
                        this.sketch.viewModel.defaultUpdateOptions.enableRotation = false;
                        this.sketch.viewModel.defaultUpdateOptions.multipleSelectionEnabled = false;
                        //clear any graphics that are on the map
                        this.extentLayer.removeAll();
                        //ensure the map is fully ready before proceeding
                        return [4 /*yield*/, this.mapView.when()];
                    case 3:
                        //ensure the map is fully ready before proceeding
                        _a.sent();
                        return [4 /*yield*/, util.sleep(wait)];
                    case 4:
                        _a.sent();
                        extent = this.getExtentWithCorrectAspectRatio(this.selectedLayout.widthInches, this.selectedLayout.heightInches, this.mapView.extent);
                        return [4 /*yield*/, this.getPolygonFromExtent(extent)];
                    case 5:
                        polygon = _a.sent();
                        graphic = new Graphic({
                            geometry: polygon,
                            symbol: new SimpleLineSymbol({
                                color: [255, 0, 0, 0.6],
                                width: 6
                            })
                        });
                        //add the extent polygon to the map
                        this.extentLayer.add(graphic);
                        this.extentLayer.visible = true;
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    PrintComponent.prototype.getPolygonFromExtent = function (extent) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var Polygon, polygon;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.Polygon];
                    case 1:
                        Polygon = _a.sent();
                        polygon = new Polygon({
                            spatialReference: extent.spatialReference
                        });
                        polygon.addRing([
                            [extent.xmin, extent.ymin],
                            [extent.xmin, extent.ymax],
                            [extent.xmax, extent.ymax],
                            [extent.xmax, extent.ymin],
                            [extent.xmin, extent.ymin]
                        ]);
                        return [2 /*return*/, polygon];
                }
            });
        });
    };
    /**
     * Given the the width and height of a template, resize the extent so that it is the same aspect ratio as that template
     */
    PrintComponent.prototype.getExtentWithCorrectAspectRatio = function (templateWidth, templateHeight, mapExtent) {
        var extent = mapExtent.clone();
        var screenWidth = extent.xmax - extent.xmin;
        var screenHeight = extent.ymax - extent.ymin;
        //find the amount to change x extent by to match ratio
        var amountToChangeX = ((screenHeight * templateWidth) / templateHeight) - screenWidth;
        //find the amount to change y extent by to match ratio. j = (yw/h) - x
        var amountToChangeY = ((screenWidth * templateHeight) / templateWidth) - screenHeight;
        var xWillChange = amountToChangeX > 0 ? false : true;
        if (xWillChange) {
            var half = amountToChangeX / 2;
            extent.xmin -= half;
            extent.xmax += half;
        }
        else {
            var half = amountToChangeY / 2;
            extent.ymin -= half;
            extent.ymax += half;
        }
        return extent.expand(extentTrimAmount);
    };
    PrintComponent.prototype.createExtentLayer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, Sketch;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.extentLayer) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({
                                id: this.extentLayerId,
                                hideInLegend: true,
                                visible: false
                            })];
                    case 1:
                        _a.extentLayer = _b.sent();
                        this.extentLayer.mapcoreProps = { hideInLegend: true };
                        return [4 /*yield*/, ESRI.Sketch];
                    case 2:
                        Sketch = _b.sent();
                        this.sketch = new Sketch({
                            layer: this.extentLayer,
                            defaultUpdateOptions: {
                                enableRotation: false,
                                multipleSelectionEnabled: false,
                                preserveAspectRatio: true,
                                toggleToolOnClick: false
                            }
                        });
                        this.sketch.watch('state', function (state) {
                            if (state === 'active') {
                                _this.sketch.viewModel.activeComponent.layer.mapcoreProps = { hideInLegend: true };
                                _this.layerService.refreshLayers();
                            }
                        });
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PrintComponent.prototype.getEmailParams = function () {
        var params = {
            ToAddresses: [this.user.emailAddress],
            FromAddress: this.user.emailAddress,
            FromName: this.user.emailAddress,
            Subject: this.mapTitle + " is complete and ready to print",
            Body: "The map " + this.mapTitle + " created by " + this.user.emailAddress + " is complete and ready to be printed. \nThe following link will expire between 15 and 30 minutes from now: {0} \n \nWithin 30 minutes the map will be moved to this location for the next 7 days: {1} \n \nIf you will need access the map after this time expires, please save it locally.",
            Cc: null,
            Bcc: null,
            IsHtml: false
        };
        return params;
    };
    PrintComponent.prototype.startPrint = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var template, extent, _a, error_2, message;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this._restarted = false;
                        this.loadingOutputUrl = true;
                        if (!this.mapTitle) {
                            this.mapTitle = this.defaultMapTitle;
                        }
                        if (!this.mapSelect) {
                            this.mapSelect = '';
                        }
                        template = {
                            selectedLayout: this.selectedLayout,
                            label: '',
                            format: this.format,
                            layoutOptions: {
                                titleText: this.mapTitle,
                                authorText: this.author,
                                copyrightText: this.copyright,
                                scalebarUnit: this.scalebarUnits,
                                customTextElements: [{ selectText: this.mapSelect }],
                                legendLayers: null
                            },
                            exportOptions: {
                                dpi: 300
                            }
                        };
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        this.sketch.complete();
                        extent = this.extentLayer.graphics.getItemAt(0).geometry.extent.clone();
                        this.removeExtentLayerFromMap();
                        _a = this;
                        return [4 /*yield*/, this.printService.printMap(this.mapView, template, extent, this.includeLegend, this.user && this.isReceiveEmailChecked ? this.getEmailParams() : null, this.scaleDrawingLayers, //TODO: Scale drawing layers is an app config option in 1.x. Set to false by default, should we enable a choice?
                            this.useCurrentBasemap, this.hasRoutingDetails)];
                    case 2:
                        _a.outputUrl = _b.sent();
                        if (!this._restarted) {
                            this.loadingOutputUrl = false;
                            this.outputLoaded = true;
                            this.onoutputloaded.emit(true);
                            this.LoggingService.Log(this.formatDisplay + " ready to download.", null, LogLevel.Info);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _b.sent();
                        message = "There was an error loading the " + this.formatDisplay + ", please try again or contact an administrator for help.";
                        if (!this._restarted) {
                            this.loadingOutputUrl = false;
                            this.errorMessage = message;
                            this.onoutputloaded.emit(false);
                            //TODO: Error reporting
                        }
                        this.LoggingService.Log(message, error_2, LogLevel.Error, !this._restarted);
                        return [3 /*break*/, 5];
                    case 4:
                        this._restarted = false;
                        return [7 /*endfinally*/];
                    case 5:
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    PrintComponent.prototype.openOutput = function () {
        window.open(this.outputUrl, '_blank');
        this.ondone.emit(true);
        this.restart();
    };
    PrintComponent.prototype.restart = function () {
        this._restarted = true;
        this.reset();
        this.onActivate();
    };
    PrintComponent.prototype.removeExtentLayerFromMap = function () {
        this.mapView.map.remove(this.extentLayer);
        this.extentLayer.removeAll();
        this.extentLayer = null;
    };
    PrintComponent.prototype.reset = function () {
        if (this.extentLayer) {
            this.removeExtentLayerFromMap();
        }
        this.loadingOutputUrl = false;
        this.outputUrl = null;
        this.outputLoaded = false;
        this.mapTitle = null;
        this.errorMessage = '';
        if (this.scaleWatcher) {
            this.scaleWatcher.remove();
        }
    };
    PrintComponent.prototype.layoutTrack = function (item) {
        return item.id;
    };
    PrintComponent.prototype.setupHandleHiddenLayer = function () {
        var _this = this;
        this.initializing = true;
        var stopInitialCheck = util.debounce(function () { _this.initializing = false; }, initilizeDebounceTime);
        this.listners.push(this.layerService.mapRef.allLayers.on('before-add', function (event) {
            if (_this.initializing && event.item.listMode === 'hide') {
                event.item.set('hideInLegend', true);
                event.item.set('drawLineToolGeneratedLayer', true);
                stopInitialCheck();
            }
        }));
        this.listners.push(this.layerService.mapRef.allLayers.on('after-remove', function (event) {
            if (event.item.get('drawLineToolGeneratedLayer')) {
                _this.initializing = true;
            }
        }));
    };
    PrintComponent.prototype.teardownHandleHiddenLayer = function () {
        while (this.listners.length) {
            this.listners.pop().remove();
        }
    };
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], PrintComponent.prototype, "active", null);
    return PrintComponent;
}(BaseComponent));
export { PrintComponent };
